import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

/**
 * A tooltip that reads like a small card — paper background, soft shadow —
 * for explanations longer than a few words.
 */
const CardTooltip: React.FC<TooltipProps> = ({ slotProps, ...props }) => (
  <Tooltip
    arrow
    placement="top"
    {...props}
    slotProps={{
      ...slotProps,
      tooltip: {
        sx: {
          bgcolor: 'background.paper',
          color: 'text.primary',
          boxShadow: 3,
          p: 1.5,
          '& .MuiTooltip-arrow': { color: 'background.paper' },
        },
      },
    }}
  />
);

export default CardTooltip;
